export default {
  banner: {
    description:
      'Obține {{range}} reducere când comanzi prin aplicația gratuită FoodAmigos. Apasă aici pentru a descărca aplicația →',
  },
  labels: {
    deals: 'Oferte',
    collecting_points: 'Colectezi deja puncte?',
    earn_points: 'Câștigă puncte și obține recompense ',
    order_again: 'Comandă din nou',
  },
  checkout_button: {
    title: 'Mergi la coș',
  },
};
